/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { calculationService } from "../../../Services/AccountingServices/calculation.service";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModalCalculation";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as dateHelper from "../../../Helpers/DateHelper";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ProductsFilterModal from "../../Common/ProductsFilterModal";
import ActionModal from "../../Common/ActionModal";
import { AuthContext } from "../../../Contexts/AuthContext";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import DatePicker, { registerLocale } from "react-datepicker";
import { useForm, Controller } from "react-hook-form";
import Tooltip from "../../Common/Tooltip";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import moment from "moment";
import { tr } from "date-fns/locale";
import XLSX from "xlsx";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
const DocumentDetails = (props) => {
  const { t: translator } = useTranslation();
  const history = useHistory();
  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { selectedLanguageId } = useContext(GlobalContext);
  const { useAccounting } = useContext(AuthContext);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [update, setUpdate] = useState(new Date());
  const [initValue, setInitValue] = useState({
    date: null,
    storeId: 0,
    partnerGuid: "",
    note: "",
    documentNumber: null,
    parentGuid: null,
    partnerName: "",
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });

  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false,
      ),
    );

    let oldDeleted2 = oldDeleted.filter((f) =>
      filterProducts.some((item) => item.productGuid === f.productGuid),
    );

    //vraćam ih na isActive true
    oldDeleted2.forEach((el) => (el.isActive = true));

    //uklanjanje duplikata
    oldDeleted = oldDeleted.filter((f) =>
      oldDeleted2.some((item) => item.productGuid !== f.productGuid),
    );

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid),
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid),
    );

    let newProducts = addedProducts.map((prod) => ({
      documentDetailGuid: prod.documentDetailGuid,
      productGuid: prod.productGuid,
      productName: prod.productName,
      priceIn: 0,
      priceOut: Number(prod.price),
      priceOut2: Number(prod.price),
      quantityIn: 0,
      margin: 0,
      tax: prod.tax,
      isActive: true,
      unitOfMeasure: prod.unitMeasureName,
    }));

    newArr = newArr.concat(newProducts);

    let shouldRemove = newArr.filter(
      (e) => e.documentDetailGuid === null && e.isActive === false,
    );

    newArr = newArr.filter((el) => !shouldRemove.includes(el));

    setIsDisabled(false);
    setProducts(newArr);
  };
  function nameFormatter(cell, row) {
    return row.isRawMaterial ? cell + "(Sirovina)" : cell;
  }

  const addNewProduct = (
    productGuid,
    productName,
    priceIn,
    taxRate,
    isRawMaterial,
  ) => {
    console.log(priceIn);
    setProducts([
      ...products,
      {
        documentDetailGuid: null,
        productGuid,
        productName,
        priceIn: 0,
        priceOut: priceIn,
        priceOut2: Number(priceIn),
        quantityIn: 0,
        margin: 0,
        tax: isRawMaterial ? 0 : taxRate,
        isActive: true,
      },
    ]);
    setIsDisabled(false);
  };

  const onSubmit = (data) => {
    var m = moment();
    var endDate = moment(dates.endDate);
    m.set(endDate.toObject());

    calculationService
      .documentUpdate(
        initValue.documentGuid,
        initValue.date,
        initValue.storeId,
        initValue.partnerGuid,
        data.note,
        dates.startDate,
        endDate,
        products,
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateSuccess-Title",
            text: "InitialState-ResultModal-UpdateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success) {
      history.push("/calculation");
    }
  };
  const handleCancel = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!useAccounting) {
      history.push("/error-page/401");
    }
    calculationService
      .getDocumentById(props.match.params.documentId)
      .then((res) => {
        if (res.data.data !== null) {
          setInitValue({
            ...initValue,
            date: res.data.data.date,
            storeId: Number(res.data.data.storeId),
            partnerGuid: res.data.data.partnerGuid,
            storeName: res.data.data.storeName,
            note: res.data.data.note,
            documentNumber: res.data.data.documentNumber,
            priceListId: res.data.data.priceListId,
            tenantId: res.data.data.tenantId,
            documentGuid: res.data.data.documentGuid,
            parentGuid: res.data.data.parentGuid,
            partnerName: res.data.data.partnerName,
          });
        }

        calculationService
          .documentDetails(props.match.params.documentId)
          .then((res) => {
            setProducts(res.data.data);
            setIsLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => err);
  }, [update]);

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;

  function currencyFormatter(cell) {
    if (typeof cell === "string" && cell.includes(",")) {
      cell = cell.replace(/,/g, ".");
    }
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(initValue.date),
    }).format(Number(cell));
  }

  const rowEvents = {
    onBlur: (e, column, columnIndex, row, rowIndex) => {
      let editedPrice = products.filter(
        (p) => p.priceOut2 !== Number(p.priceOut),
      );
      if (editedPrice.length > 0) {
        setShowDatePicker(false);
      } else {
        setShowDatePicker(false);
      }
    },
  };

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(initValue.date),
    }).format(Number(cell));
  }
  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      searchable: false,
      hidden: initValue.documentNumber ? true : false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          let newArr = [...products];
          let item = newArr.find((p) => p.productGuid === row.productGuid);
          item.isActive = false;

          setProducts(newArr);
          setIsDisabled(false);
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      formatter: nameFormatter,
      editable: false,
    },
    {
      dataField: "unitOfMeasure",
      text: translator("InitialState-UnitOfMeasure"),
      editable: false,
    },
    {
      dataField: "priceIn",
      text: `${translator("Nabavna cijena")}*`,
      formatter: currencyFormatter,
      editable: initValue.documentNumber ? false : true,
      searchable: false,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegativeMsg"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("PriceMaxMsg"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
    {
      dataField: "margin",
      text: `${translator("InitialState-Margin")}*`,
      searchable: false,
      formatter: percentFormatter,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        setIsDisabled(false);
        return true;
      },
      // events: {
      //   onClick: (e, column, columnIndex, row, rowIndex) => {
      //     console.log("margin", row.margin);
      //     console.log(
      //       "data",
      //       Number(row.price3) + Number((row.price3 * row.margin) / 100)
      //     );
      //   },
      // },
    },
    {
      dataField: "tax",
      text: `${translator("InitialState-Tax")}*`,
      editable: false,
      formatter: percentFormatter,
    },
    {
      dataField: "priceOut2",
      text: `${translator("InitialState-Price")}*`,
      formatter: currencyFormatter,
      editable: initValue.documentNumber ? false : true,
      searchable: false,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegativeMsg"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("PriceMaxMsg"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
    {
      dataField: "quantityIn",
      text: `${translator("InitialState-Quantity")}*`,
      editable: initValue.documentNumber ? false : true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
  ];
  function percentFormatter(cell) {
    return cell + "%";
  }
  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmLock = () => {
    calculationService
      .documentLock(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockSuccess-Title",
            text: "InitialState-ResultModal-LockSuccess-Text",
            show: true,
            success: true,
            btnClass: "btn btn-primary",
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockError-Title",
            text: "InitialState-ResultModal-LockError-Text",
            show: true,
            success: false,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const confirmCancel = () => {
    calculationService
      .documentCancel(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CancelSuccess-Title",
            text: "InitialState-ResultModal-CancelSuccess-Text",
            show: true,
            success: true,
            btnClass: "btn btn-primary",
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CancelError-Title",
            text: "InitialState-ResultModal-CancelError-Text",
            show: true,
            success: false,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const confirmDelete = () => {
    calculationService
      .documentDelete(props.match.params.documentId)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteSuccess-Title",
            text: "InitialState-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteError-Title",
            text: "InitialState-ResultModal-DeleteError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "InitialState-ResultModal-DeleteError-Title",
          text: "InitialState-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
          success: false,
        }),
      );
  };

  const handleLockDocument = () => {
    setActionModal({
      title: "InitialState-DocumentLock-Title",
      text: "InitialState-DocumentLock-Text",
      confirmBtn: "Confirm-Lock",
      confirmAction: confirmLock,
      show: true,
    });
  };

  const handleCancelDocument = () => {
    setActionModal({
      title: "InitialState-DocumentCancel-Title",
      text:
        initValue.parentGuid != null
          ? "Document-Cancel-Forbbiden"
          : "InitialState-DocumentCancel-Text",
      confirmBtn: initValue.parentGuid != null ? "" : "Confirm-Cancel",
      confirmAction: initValue.parentGuid != null ? () => false : confirmCancel,
      show: true,
    });
  };

  const handleDeleteDocument = () => {
    setActionModal({
      title: "InitialState-DocumentDelete-Title",
      text: "InitialState-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const exportExcelFunction = () => {
    var ws_name = `Primka ${initValue.documentNumber}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [translator("InvIssReport-Filters-Tenants"), "Prodajno mjesto"],
      ["", initValue.storeName],
      [translator("InvoiceCashBalancePDF-Date"), "Broj dokumenta"],
      [dateHelper.formatUtcToDate(initValue.date), initValue.documentNumber],
      ["Dobavljač", initValue.partnerName],
      [
        translator("Proizvod"),
        `Nabavna cijena (${activeCurrencyByDate(initValue.date)})`,
        "Margina (%)",
        "PDV (%)",
        `Prodajna cijena (${activeCurrencyByDate(initValue.date)})`,
        "Količina",
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = products.map((x) => {
      const array = [
        x.productName,
        x.priceIn,
        x.margin,
        x.tax,
        x.priceOut2,
        x.quantityIn,
      ];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, "Primka");
    XLSX.writeFile(wb, ws_name);
  };

  console.log("PRODUCTS ", products);

  return (
    <>
      <CardWrap subtitle={translator("DocumentDetails")}>
        {!isLoading && (
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-IndexData")}
                </legend>
                <div className="form-group">
                  <div>
                    <label className="boldedDocNumber">
                      <b>{translator("InitialState-DocumentNumber")}:</b>{" "}
                      {initValue.documentNumber
                        ? initValue.documentNumber
                        : translator("Document-NotLocked")}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Date")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.date)}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Store")}:</b>{" "}
                      {initValue.storeName}
                    </label>
                  </div>
                  <div className="form-group">
                    <label>
                      <b>{translator("InitialState-Note")}:</b>
                    </label>
                    <textarea
                      disabled={initValue.documentNumber}
                      name="note"
                      ref={register({ maxLength: 250 })}
                      className="form-control"
                      rows={4}
                      id="textArea"
                      defaultValue={initValue.note}
                      onChange={() => setIsDisabled(false)}
                    ></textarea>
                    {errors.note && errors.note.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                  </div>
                  {showDatePicker ? (
                    <>
                      <div className="form-group">
                        <label>{translator("Predisposition-DateFrom")}</label>
                        <Tooltip
                          text={translator("PriceChange-DateFrom-Msg")}
                        />
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text"
                              id="basic-addon1"
                            >
                              <img src={iconcontentcalendar} alt="calendar" />
                            </span>
                          </div>
                          <Controller
                            as={DatePicker}
                            control={control}
                            autoComplete="off"
                            className="form-control"
                            dateFormat="dd.MM.yyyy"
                            name="startDate"
                            showYearDropdown={true}
                            rules={{ required: true }}
                            locale={
                              Number(selectedLanguageId) === 1 ? "hr" : "en"
                            }
                            valueName="selected"
                            onChange={function ([selected]) {
                              setDates({ ...dates, startDate: selected });
                              return selected;
                            }}
                            defaultValue={new Date()}
                            minDate={new Date()}
                          />
                          {errors.startDate &&
                            errors.startDate.type === "required" && (
                              <p className="col-md-10 pl-0 text-danger">
                                {translator("ValidationMsg-RequiredField")}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label>{translator("Predisposition-DateTo")}</label>
                        <Tooltip text={translator("PriceChange-DateTo-Msg")} />
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text"
                              id="basic-addon1"
                            >
                              <img src={iconcontentcalendar} alt="calendar" />
                            </span>
                          </div>
                          <Controller
                            as={DatePicker}
                            control={control}
                            autoComplete="off"
                            className="form-control"
                            dateFormat="dd.MM.yyyy"
                            name="endDate"
                            showYearDropdown={true}
                            rules={{ required: true }}
                            locale={
                              Number(selectedLanguageId) === 1 ? "hr" : "en"
                            }
                            valueName="selected"
                            onChange={function ([selected]) {
                              setDates({ ...dates, endDate: selected });
                              return selected;
                            }}
                            defaultValue={new Date()}
                            minDate={new Date()}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </fieldset>

              <div
                class="custom-card-footer row"
                style={{ borderTop: "1px solid #ccc", paddingTop: "22px" }}
              >
                <label class="control-label col-md-12">
                  * {translator("DangerArea")}
                </label>
                <div className="col-md-6">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleLockDocument();
                    }}
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                  >
                    {translator("Btn-Conclude")}
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleCancelDocument();
                    }}
                    disabled={!initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                  >
                    {translator("Btn-CancelDoc")}
                  </button>
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteDocument();
                    }}
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-danger btn-block"
                  >
                    {translator("Btn-RemoveDoc")}
                  </button>
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      exportExcelFunction();
                    }}
                    disabled={initValue.documentNumber ? false : true}
                    className="btn btn-outline-secondary btn-block"
                  >
                    {translator("Preuzmi dokument")}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-Items")}
                </legend>
                <ToolkitProvider
                  keyField="productGuid"
                  data={products.filter((item) => item.isActive === true)}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      <div className="form-group">
                        <SearchBar
                          {...props.searchProps}
                          placeholder={translator("Search")}
                        />
                        &nbsp;
                        {!initValue.documentNumber ? (
                          <>
                            <div className="form-group">
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowFilterModal(true);
                                }}
                              >
                                <span className="icon icon-filter"></span>{" "}
                                {translator("Filter")}
                              </button>
                              &nbsp;
                              <button
                                className="btn btn-primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (initValue.storeId === "") {
                                    setModalValidationMsg(
                                      "ValidationMsg-SelectStore",
                                    );
                                  } else setShowProductModal(true);
                                }}
                              >
                                {translator("InitialState-AddProduct")}
                              </button>
                              <span className="text-danger ml-2">
                                {translator(modalValidationMsg)}
                              </span>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      <hr />
                      <BootstrapTable
                        {...props.baseProps}
                        keyField="productGuid"
                        rowEvents={rowEvents}
                        noDataIndication={translator("No-Data")}
                        pagination={paginationFactory(options)}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          /*afterSaveCell: (oldValue, newValue, row, column) => {
                            if (column.dataField == "price3") {
                              row.price3 = newValue;
                              /// 100 * (1 + 0/100) * (1 +25/100) = 125
                              /// 100 * (1 + 1/100) * (1 +25/100) = 100 * 1.01 * 1.25
                              row.price =
                                Number(newValue) *
                                (1 + (row.margin / 100)) *
                                (1 + (row.tax / 100));
                            }
                            if (column.dataField == "margin") {
                              row.price =
                                Number(row.price3) *
                                (1 + (newValue / 100)) *
                                (1 + +row.tax / 100);
                              row.margin = +newValue;
                            }
                            if (column.dataField == "price") {
                              row.price = +newValue;
                              let netPrice = newValue / (1 + (row.tax / 100));

                              let diff = netPrice - row.price3;

                              let margin = (diff / row.price3) * 100;
                              console.log("nn", netPrice);
                              console.log("mm", margin);
                              //130 -(130 * (25/100) / 1+(25/100)) =130 -(130 *0.25 / 1.25) = 130-26 = 104
                              //

                              row.margin = +(Number(((netPrice - row.price3) / row.price3) * 100).toFixed(4));
                            }

                            setUpdate(new Date());
                          },*/
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            if (column.dataField == "priceIn") {
                              row.priceIn = newValue;
                              let netPrice =
                                row.priceOut2 / (1 + row.tax / 100);
                              //row.priceOut2 = Number(newValue) * (1 + (+row.margin / 100)) * (1 + (+row.tax / 100));

                              row.margin = +Number(
                                ((netPrice - newValue) / newValue) * 100,
                              ).toFixed(4);
                            }
                            if (column.dataField == "margin") {
                              row.priceOut2 =
                                Number(row.priceIn) *
                                (1 + +newValue / 100) *
                                (1 + +row.tax / 100);
                              row.margin = +newValue;
                            }
                            if (column.dataField == "priceOut2") {
                              row.price = +newValue;
                              let netPrice = newValue / (1 + row.tax / 100);
                              //130 -(130 * (25/100) / 1+(25/100)) =130 -(130 *0.25 / 1.25) = 130-26 = 104
                              //

                              row.margin = Number(
                                ((netPrice - row.priceIn) / row.priceIn) * 100,
                              ).toFixed(4);
                            }
                          },
                        })}
                      />
                      <p>
                        <span className="editableColumns">*</span>
                        {translator("EditableTableColumns")}
                      </p>
                    </>
                  )}
                </ToolkitProvider>
              </fieldset>
            </div>
            <div
              className="container-fluid mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-outline-secondary"
                onClick={handleCancel}
              >
                {translator("POS-New_EditPOS-Close")}
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                disabled={isDisabled}
                type="submit"
              >
                {translator("POS-New_EditPOS-Save")}
              </button>
            </div>
          </form>
        )}
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      {initValue.date !== null && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={initValue.storeId}
          documentOption={1}
          prodList={products.filter((item) => item.isActive === true)}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {initValue.date !== null && (
        <AddProductModal
          show={showProductModal}
          tenantId={initValue.tenantId}
          priceListId={initValue.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default DocumentDetails;
